import React from 'react';
import { useForm } from 'react-hook-form';

import { FormGroup } from '../components/FormGroup';
import { useApp } from '../store/AppContext';
import { supabase } from '../supabaseClient';

const MIN_LENGTH = 8;

/* Choix du mot de passe (invitation ou récupération). Les règles sont vérifiées à l'envoi :
   d'abord la confirmation, puis la longueur. */
export default function PasswordForm({ invite }) {
  const { setIsRecovery } = useApp();
  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: { password: '', confirm: '' },
    reValidateMode: 'onSubmit',
  });

  const onSubmit = async ({ password }) => {
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setError('root.server', { message: error.message });
      return;
    }
    try {
      window.history.replaceState(null, '', window.location.pathname);
    } catch (e) {}
    setIsRecovery(false);
    reset();
  };

  const message =
    errors.confirm?.message || errors.password?.message || errors.root?.server?.message;
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup label={invite ? 'Votre mot de passe' : 'Nouveau mot de passe'}>
        <input
          className="input"
          type="password"
          autoFocus
          placeholder="Minimum 8 caractères"
          {...register('password', {
            // minLength ignore un champ vide : required couvre ce cas avec le même message.
            required: 'Minimum 8 caractères.',
            minLength: { value: MIN_LENGTH, message: 'Minimum 8 caractères.' },
          })}
        />
      </FormGroup>
      <FormGroup label="Confirmer">
        <input
          className="input"
          type="password"
          placeholder="Répétez le mot de passe"
          {...register('confirm', {
            validate: (value, values) =>
              value === values.password || 'Les mots de passe ne correspondent pas.',
          })}
        />
      </FormGroup>
      {message && <div className="text-[11px] text-[#dc2626] mb-[10px]">{message}</div>}
      <button type="submit" className="btn btn-primary w-[100%] justify-center py-[8px] px-[12px]">
        {invite ? 'Créer mon compte' : 'Enregistrer le mot de passe'}
      </button>
    </form>
  );
}
